export default __webpack_public_path__ + "static/media/not-available-banner.da536a6e.png";